import { Layout, Menu } from 'antd';
import type { MenuProps } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const { Sider } = Layout;

interface AppSiderProps {
  items: MenuProps['items'];
  width?: number;
}

export function AppSider({ items, width = 220 }: AppSiderProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedKeys = (() => {
    const path = location.pathname;
    const keys = (items ?? [])
      .map((item) => (item && 'key' in item ? String(item.key) : ''))
      .filter(Boolean)
      .sort((a, b) => b.length - a.length);
    const matched = keys.find((key) => path === key || path.startsWith(`${key}/`));
    return [matched ?? path];
  })();

  return (
    <Sider width={width} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
      <Menu
        mode="inline"
        selectedKeys={selectedKeys}
        items={items}
        onClick={({ key }) => navigate(key)}
        style={{ height: '100%', borderInlineEnd: 0 }}
      />
    </Sider>
  );
}
